// src/components/ads-admin/Collapsible.jsx
import React from "react";

export default function Collapsible({ title, subtitle, right, open, setOpen, children }) {
  return (
    <section
      style={{
        background: "#fff",
        border: "1px solid var(--border)",
        borderRadius: 16,
        padding: 16,
        boxShadow: "0 10px 24px rgba(15,23,42,0.06)",
      }}
    >
      <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
            <h3 style={{ margin: 0, fontSize: 14, fontWeight: 900, color: "#111827" }}>{title}</h3>
            {right}
          </div>
          {subtitle && (
            <p style={{ margin: "6px 0 0", fontSize: 13, color: "#6b7280", lineHeight: 1.5 }}>{subtitle}</p>
          )}
        </div>
        <button
          className="btn-secondary"
          onClick={() => setOpen?.(!open)}
          style={{ padding: "8px 12px", borderRadius: 12, whiteSpace: "nowrap" }}
          title={open ? "Collapse" : "Expand"}
        >
          {open ? "Hide" : "Show"}
        </button>
      </div>
      {open && <div style={{ marginTop: 14 }}>{children}</div>}
    </section>
  );
}